import React, { useEffect, useState } from "react";

import "./progressRing.css";

function ProgressRing({
  radiusProp,
  strokeProp,
  progress,
  strokeColor = "white",
}) {
  //const [radius, setRadius] = useState(0);
  //const [stroke, setStroke] = useState(0);

  const [normalizedRadius, setNormalizedRadius] = useState(0);
  const [circumference, setCircumference] = useState(0);

  useEffect(() => {
    reCalc();
  }, [radiusProp]);

  useEffect(() => {
    reCalc();
  }, [strokeProp]);

  function reCalc() {
    let newNormalizedRadius = radiusProp - strokeProp * 2;
    setNormalizedRadius(newNormalizedRadius);
    setCircumference(newNormalizedRadius * 2 * Math.PI);
  }

  const strokeDashoffset = circumference - (progress / 100) * circumference;

  return (
    <div
      className="moki_wrapper"
      style={{
        height: `${radiusProp * 2}px`,
        width: `${radiusProp * 2}px`,
      }}
    >
      <div className="moki_outerDiv">
        <div className="moki_innerDiv1">
          <svg height={radiusProp * 2} width={radiusProp * 2}>
            <circle
              stroke="rgba(233, 223, 223, 0.4)"
              fill="transparent"
              strokeWidth={strokeProp}
              style={{ strokeDashoffset }}
              r={normalizedRadius}
              cx={radiusProp}
              cy={radiusProp}
            />
            <circle
              stroke={strokeColor}
              fill="transparent"
              strokeWidth={strokeProp}
              strokeDasharray={circumference + " " + circumference}
              style={{ strokeDashoffset }}
              r={normalizedRadius}
              cx={radiusProp}
              cy={radiusProp}
            />
          </svg>
        </div>
        <div className="moki_innerDiv1">
          <label
            htmlFor="colFormLabel"
            className="col-form-label-sm"
            style={{ fontSize: "0.65rem", fontWeight: "bold" }}
          >
            {progress}
          </label>
        </div>
      </div>
    </div>
  );

  /*return (
    <div
      className="moki_wrapper"
      style={{
        height: `${radiusProp * 2}px`,
        width: `${radiusProp * 2}px`,
      }}
    >
      <div className="moki_outerDiv">
        <div className="moki_innerDiv1">Hello World!</div>
        <div className="moki_innerDiv1">{progress}</div>
      </div>
    </div>
  );*/
}

/*
  return (
    <>
      <div
        style={{
          position: "relative",
          height: "{radiusProp * 2}",
          width: "{radiusProp * 2}",
        }}
      >
        <svg height={radiusProp * 2} width={radiusProp * 2}>
          <circle
            stroke="rgba(233, 223, 223, 0.4)"
            fill="transparent"
            strokeWidth={strokeProp}
            style={{ strokeDashoffset }}
            stroke-width={strokeProp}
            r={normalizedRadius}
            cx={radiusProp}
            cy={radiusProp}
          />
          <circle
            stroke={strokeColor}
            fill="transparent"
            strokeWidth={strokeProp}
            strokeDasharray={circumference + " " + circumference}
            style={{ strokeDashoffset }}
            stroke-width={strokeProp}
            r={normalizedRadius}
            cx={radiusProp}
            cy={radiusProp}
          />
        </svg>
        <span style={{ position: "absolute" }}>{progress}</span>
      </div>
    </>
  );
}
*/
export default ProgressRing;
